export const REDUX_NAMESPACE = 'IMPORTED_ASSET';
